import React from 'react';
import IconSvg, { IconSvgProps } from './IconSvg';

const Menu = (props: IconSvgProps) => (
  <IconSvg {...props}>
    <path d="M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z" />
  </IconSvg>
);

export default Menu;
